'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (pathname) {
  return {
    pathname: pathname,
    listen: function listen() {
      return function () {};
    }
  };
};

module.exports = exports['default'];